import type { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const CostForm_VariableCost_Create_Mutation = graphql(`
  mutation CostForm_VariableCost_Create(
    $variableCost: VariableCostInput!
    $versionData: VersionDataInput
  ) {
    createVariableCost(doc: $variableCost, versionData: $versionData) {
      _id
    }
  }
`);

export type VariableCostInput = VariablesOf<
  typeof CostForm_VariableCost_Create_Mutation
>['variableCost'];

export type VariableCost_Create_Result = ResultOf<
  typeof CostForm_VariableCost_Create_Mutation
>;

export const useCreateVariableCostMutation = () =>
  useGraphQLMutation(CostForm_VariableCost_Create_Mutation);
